import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output , signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Route, Turn } from 'src/app/models/route';
import { LanguageService } from 'src/app/services/account/language.service';
import { SettingsService, Unit } from 'src/app/services/account/settings.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { TurnValueIntegerThousandsPipe } from 'src/app/pipes/turn-value-integer-thousands.pipe';
import { ValueIntegerPipe } from 'src/app/pipes/value-integer.pipe';
import { SvgRecolorDirective } from 'src/app/directives/svg-recolor.directive';
import { SvgGradientStop } from 'src/app/services/media/svg-recolor.service';

interface TurnDistanceDisplay {
  value: number;
  unit: 'm' | 'km' | 'yard' | 'mi';
  isThousands: boolean;
}

@Component({
  standalone: true,
  selector: 'app-itinerary',
  templateUrl: './itinerary.component.html',
  styleUrls: ['./itinerary.component.scss'],
  imports: [TurnValueIntegerThousandsPipe, ValueIntegerPipe, SvgRecolorDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItineraryComponent implements OnInit {
  @Input() routeData: Route | null = null;
  @Input() loadingMap: string = '';
  @Input() noRoute: boolean = false;
  @Input() itineraryNextTurnIdx: number = -1;
  @Input() navigation: boolean = false;

  @Output() turnClick = new EventEmitter<Turn>();

  public readonly itineraryDropdown = signal<boolean>(false);

  public readonly baseGradientStops: SvgGradientStop[] = [
    { offset: 0, color: '--base-gradient-color-1' },
    { offset: 1, color: '--base-gradient-color-2' }
  ];

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private cdr: ChangeDetectorRef,
    public languageService: LanguageService,
    public settingsService: SettingsService,
    public utilsService: UtilsService
  ) { }

  ngOnInit(): void {
    // OnPush: re-render translated labels when the language changes.

    // OnPush: re-render turn distances when the unit setting (metric/imperial) changes.
  }

  public toggle(): void {
    this.itineraryDropdown.set(!this.itineraryDropdown());
  }

  public onTurnClick(turn: Turn): void {
    this.turnClick.emit(turn);
  }

  public turnDistanceDisplay(distance: number): TurnDistanceDisplay {
    const isMetric = this.settingsService.getUnit().Distance == Unit.Metric;

    if (isMetric) {
      return distance >= 1000
        ? { value: distance / 1000, unit: 'km', isThousands: true }
        : { value: distance, unit: 'm', isThousands: false };
    }

    return this.utilsService.mToYard(distance) >= 1760
      ? { value: distance * 0.000621371192, unit: 'mi', isThousands: true }
      : { value: distance * 1.0936133, unit: 'yard', isThousands: false };
  }
}
